export default "__VITE_ASSET__258b76f1__"